import { Variable } from 'domain/models';

export const ALL_VARIABLES = [
	Variable.TAS,
	Variable.PR,
	Variable.HURS,
	Variable.SFCWIND,
	Variable.WGUST,
	Variable.IR,
	Variable.LEAFWETNESS,
];
